import React from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import Col from '../../../elements/Col';
import Row from '../../../elements/Row';
import Box from '../../../elements/Box';

const styles = {
  content: {
    container: {
      width: '100%',
      paddingLeft: '5px',
      paddingRight: '5px'
    },
    wrapper: {
      height: '100%',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      marginTop: '7px',
      position: 'absolute'
    },
    firstBox: {
      height: '18px',
      padding: 0,
      marginLeft: '25px',
      marginRight: '25px'
    },
    box: {
      height: '18px'
    },
    row: {
      margin: '0 auto',
      paddingLeft: '18px',
      paddingRight: '18px'
    },
    shortRow: {
      paddingLeft: '28px',
      paddingRight: '28px',
      margin: '0 auto'
    },
    longRow: {
      paddingTop: '3px',
      margin: '0 auto',
      paddingBottom: '4px',
      paddingLeft: '20px',
      paddingRight: '20px'
    },
    extendedLayoutLargeRow: {
      height: '9px',
      marginInline: '15px'
    },
    extendedLayoutShortRow: {
      height: '18px',
      marginInline: '21px',
      borderTop: 'solid white 1px'
    }
  }
};

const SkeletonCalendarCard = (props) => {
  const [className, style] = useStyles(props);
  const { content } = styles;
  const {
    showOneRow = false,
    showExtendedLayout = false,
    renderDayAtom,
    day,
    dayDateFormat,
    dayCard,
    dayCardDaySkeletonStyle = {}
  } = props;
  if (showOneRow) {
    return (
      <Box style={content.container} dataTestId="skeletonCalendarCard" {...dayCardDaySkeletonStyle}>
        <Box className="fr-skeleton-box-background" style={content.box}>
          &nbsp;
        </Box>
      </Box>
    );
  }
  if (showExtendedLayout) {
    return (
      <Box style={content.container} dataTestId="skeletonCalendarCard" {...dayCardDaySkeletonStyle}>
        <Box
          className="fr-skeleton-box-background fr-large-bar"
          style={content.extendedLayoutLargeRow}
        >
          &nbsp;
        </Box>
        <Box
          className="fr-skeleton-box-background fr-short-bar"
          style={content.extendedLayoutShortRow}
        >
          &nbsp;
        </Box>
      </Box>
    );
  }
  return (
    <Box
      className={`${className} fr-skeleton`}
      style={style}
      dataTestId="skeletonCalendarCard"
      {...dayCardDaySkeletonStyle}
    >
      <Box style={content.wrapper}>
        <Row gutters>
          <Col xs="2">{renderDayAtom(day, dayDateFormat, dayCard)}</Col>
          <Col xs="8">
            <Box className="fr-skeleton-box-background" style={content.firstBox} />
          </Col>
        </Row>
        <Row gutters>
          <Col xs="8" style={content.longRow}>
            <Box className="fr-skeleton-box-background" style={content.box} />
          </Col>
        </Row>
        <Row gutters>
          <Col xs="6" style={content.row}>
            <Box className="fr-skeleton-box-background" style={content.box} />
          </Col>
        </Row>
        <Row gutters>
          <Col xs="6" style={content.row}>
            <Box className="fr-skeleton-box-background" style={content.box} />
          </Col>
        </Row>
      </Box>
    </Box>
  );
};
SkeletonCalendarCard.componentName = 'SkeletonCalendarCard';

export default SkeletonCalendarCard;
